<ul class="circulation-info flex-row-inline">
  @if (copies !== undefined) {
    <li>Copies: {{ copies }}</li>
  }
  @if (available !== undefined) {
    <li>Available: {{ available }}</li>
  }
  @if (holds !== undefined) {
    <li>Holds: {{ holds }}</li>
  }
</ul>
